import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Language {
  code: string;
  name: string;
  native_name: string;
  dir: 'ltr' | 'rtl';
  hreflang: string;
  is_default: boolean;
  is_active: boolean;
}

export const useLanguages = () => {
  return useQuery({
    queryKey: ['languages'],
    queryFn: async (): Promise<Language[]> => {
      const { data, error } = await supabase
        .from('languages')
        .select('code, name, native_name, dir, hreflang, is_default, is_active')
        .eq('is_active', true)
        .order('is_default', { ascending: false });

      if (error) throw error;
      const list = (data || []).map((l: any) => ({
        code: l.code,
        name: l.name,
        native_name: l.native_name,
        dir: (l.dir === 'rtl' ? 'rtl' : 'ltr') as 'ltr' | 'rtl',
        hreflang: l.hreflang || l.code,
        is_default: !!l.is_default,
        is_active: !!l.is_active,
      }));
      return list;
    },
  });
};
